import { createSlice } from '@reduxjs/toolkit';

import { RecurrenceSortByEnum } from '@pages/organizer/Finance/components/tabs/Bills/store/bills-types';
import { isListOver } from '@shared/functions/isListOver';

import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  isFetchingInitialData: false,
  paymentHistoryData: [],
  isFetchingWithFilter: false,
  billsList: [],
  dashboardInfo: {},
  billInfo: null,
  billAllList: null,
  billInfoCalendarData: [],
  billDetailsPaymentList: [],
  billDetailsSpending: null,
  recurringPageView: 'monthly',
  recurringMonthView: localStorage.getItem('recurringMonthView') || 'list',
  recurringMonthTabletView: localStorage.getItem('recurringMonthTabletView') || 'list',
  currentDate: new Date(),
  filters: {
    sort_by: RecurrenceSortByEnum.due_date,
    item_ids: null,
    hubs: null,
    query: '',
  },
};

export const billsSlice = createSlice({
  name: 'bills',
  initialState,
  reducers: {
    setBillsDate: (state, action: PayloadAction<Date | null>) => {
      state.currentDate = action.payload;
    },
    setRecurringMonthView(state, action: PayloadAction<string>) {
      state.recurringMonthView = action.payload;
      localStorage.setItem('recurringMonthView', action.payload);
    },
    setRecurringPageView(state, action: PayloadAction<string>) {
      state.recurringPageView = action.payload;
    },
    setTabletRecurringMonthView(state, action: PayloadAction<string>) {
      state.recurringMonthTabletView = action.payload;
      localStorage.setItem('recurringMonthTabletView', action.payload);
      if (action.payload !== 'widgets') {
        state.recurringMonthView = action.payload;
        localStorage.setItem('recurringMonthView', action.payload);
      }
    },
    setBillsCalendarData: (state, action: PayloadAction<any>) => {
      state.billInfoCalendarData = action.payload;
    },
    setBillsList: (state, action: PayloadAction<any>) => {
      state.billsList = action.payload;
      state.isListOver = isListOver(action.payload);
    },
    setBillsAllList: (state, action: PayloadAction<any>) => {
      state.billAllList = action.payload;
    },
    setBillsFilters: (state, action: PayloadAction<object>) => {
      state.filters = action.payload;
    },
    removeBillsItem: (state, action: PayloadAction<number>) => {
      state.billsList.data = state.billsList.data.filter((item: any) => item.id !== action.payload);
    },

    updateBillPaymentItem: (state, action: PayloadAction<any>) => {
      state.billsItem.payments = state.billsItem.payments.map((item: any) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
    },
    addBillsItem: (state, action: PayloadAction<any>) => {
      state.billsList.data.push(action.payload);
    },
    updateBillsItem: (state, action: PayloadAction<any>) => {
      state.billsList.data = state.billsList.data.map((item: any) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
    },
    updateSomeBillsItemFields: (state, action: PayloadAction<any>) => {
      state.billsList.data = state.billsList.data.map((item: any) => {
        if (item.id === action.payload.id) {
          return { ...item, ...action.payload };
        }
        return item;
      });
    },
    setBillsQuery: (state, action: PayloadAction<string | null>) => {
      state.query = action.payload;
    },
    resetBillsData: (state) => {
      return {
        ...initialState,
        recurringPageView: state.recurringPageView,
        recurringMonthView: state.recurringMonthView,
        recurringMonthTabletView: state.recurringMonthTabletView,
      };
    },

    setBillInfo: (state, action: PayloadAction<any>) => {
      state.billInfo = action.payload;
    },
    setBillDetailsPaymentList: (state, action: PayloadAction<any>) => {
      state.billDetailsPaymentList = action.payload;
    },
    setBillDetailsSpending: (state, action: PayloadAction<any>) => {
      state.billDetailsSpending = action.payload;
    },
    resetBillsDetailsData: (state) => {
      return { ...state, billInfo: null, billDetailsPaymentList: [], billDetailsSpending: null };
    },
  },
});

export const {
  setBillsCalendarData,
  setRecurringMonthView,
  setBillInfo,
  setBillsList,
  setTabletRecurringMonthView,
  updateBillPaymentItem,
  setRecurringPageView,
  setBillDetailsSpending,
  setBillsAllList,
  setBillsDate,
  resetBillsDetailsData,
  resetBillsData,
  setBillsFilters,
  setBillDetailsPaymentList,
} = billsSlice.actions;
export default billsSlice.reducer;
